import { useTranslation } from 'react-i18next';
import { Link, Outlet } from '@tanstack/react-router';
import { IfHasPermission, NavbarDefault, SupportModal } from 'app/components';
import { useUser } from 'app/state/contexts/UserContext';

const Dashboard = () => {
  const { t } = useTranslation(['common', 'dashboard']);

  const { selectedOrganization, organizations } = useUser();

  if (!selectedOrganization) {
    return (
      <div>
        <div>{t('common:no-organization-message')}</div>
        <NavbarDefault />
      </div>
    );
  }

  return (
    <div className="project--details grid--container full--height columns">
      <div className="content">
        <div className="content-title">
          <h1>{organizations?.find((o) => o.id === selectedOrganization)?.name}</h1>
        </div>
        <div className="menu--layout">
          <Link to="/" activeOptions={{ exact: true }} activeProps={{ className: 'active' }}>
            {t('dashboard:nav-link.overview')}
          </Link>
          <IfHasPermission permission="ORGANIZATION_CREATE">
            <Link to="/users" activeProps={{ className: 'active' }}>
              {t('dashboard:nav-link.users')}
            </Link>
          </IfHasPermission>
        </div>
        <Outlet />
        <NavbarDefault />
        <SupportModal />
      </div>
    </div>
  );
};

export default Dashboard;
